import { ProductContext } from "./ProductContext";
import { Designation } from "./elements/Designation";
import { ShortDescription } from "./elements/ShortDescription";
import { PrimaryImage } from "./elements/PrimaryImage";
import { PreferredIndicator } from "./elements/PreferredIndicator";
import { PrimaryImageWithLogos } from "./elements/PrimaryImageWithLogos";
import { FullDesignation } from "~/feature/Product/elements/FullDesignation";
import { PdpLink } from "~/feature/Product/elements/PdpLink";

export const Product = {
  PdpLink,
  Designation,
  ShortDescription,
  PrimaryImage,
  PreferredIndicator,
  PrimaryImageWithLogos,
  FullDesignation,
  Context: ProductContext,
};
